"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AbstractInitializer {
    constructor(name, cache) {
        this.isInitialized = null;
        this.initializePromise = null;
        this.ensureInitialized = async () => {
            if (this.isInitialized === null) {
                this.isInitialized =
                    (await this.cache
                        .getNumber(this.name)
                        .withDefault(0)
                        .asPromise()) === 1;
            }
            if (this.isInitialized) {
                return;
            }
            if (this.initializePromise === null) {
                this.initializePromise = this.initializer();
            }
            return await this.initializePromise;
        };
        this.initializer = async () => {
            await this.initialize();
            await this.cache.setNumber(this.name, 1).asPromise();
            this.isInitialized = true;
        };
        this.name = name;
        this.cache = cache;
    }
}
exports.default = AbstractInitializer;
//# sourceMappingURL=AbstractInitializer.js.map